import React from "react";
import { buildFBRLink, buildATLLink } from "../utils";

export function ResultCard({ result, ntn, strn, qrAnalysis, isSRB, t }) {
  const { score, status, label, signals } = result;
  const colorMap = {
    registered: { border: "#16a34a", badge: "#16a34a" },
    partial:    { border: "#d97706", badge: "#d97706" },
    weak:       { border: "#b45309", badge: "#b45309" },
    not_found:  { border: "#dc2626", badge: "#dc2626" },
  };
  const c = colorMap[status] || colorMap.not_found;
  const verifyUrl   = isSRB ? "https://e.srb.gos.pk/Registration/onlinesearchTaxpayer.aspx" : buildFBRLink(ntn, strn);
  const verifyLabel = isSRB ? "🏛️ " + t("verify_on_srb") + " →" : "🏛️ " + t("verify_on_fbr") + " →";
  return (
    <div className="result-card" style={{ borderColor: c.border }}>
      <div className="result-header">
        <div className="result-badge" style={{ background: c.badge }}>{t(label)}</div>
        <div className="result-score">
          <span className="score-num" style={{ color: c.badge }}>{score}</span>
          <span className="score-den">/100</span>
        </div>
      </div>
      <div className="score-bar"><div className="score-fill" style={{ width:`${score}%`, background:c.badge }} /></div>
      <div className="signals">
        {signals.map((s,i) => <div key={i} className={`signal signal-${s.type}`}>{s.text}</div>)}
      </div>
      {(ntn || strn) && (
        <div className="result-actions">
          <a className="fbr-btn" href={verifyUrl} target="_blank" rel="noopener noreferrer">{verifyLabel}</a>
          {ntn && !isSRB && <a className="atl-btn" href={buildATLLink(ntn)} target="_blank" rel="noopener noreferrer">📋 Check ATL Status</a>}
          {isSRB && <a className="atl-btn" href="https://e.srb.gos.pk" target="_blank" rel="noopener noreferrer">🔍 SRB Portal</a>}
        </div>
      )}
      {qrAnalysis?.isFBRPOS && qrAnalysis.posInvoiceNum && (
        <a className="pos-btn" href={`https://e.fbr.gov.pk/esbn/Verification?InvNum=${qrAnalysis.posInvoiceNum}`} target="_blank" rel="noopener noreferrer">
          🔍 Verify POS Invoice #{qrAnalysis.posInvoiceNum} on FBR
        </a>
      )}
      <div className="result-note">{t("result_note")}</div>
    </div>
  );
}
